<nav
  class="gcweb-menu"
  typeof="SiteNavigationElement"
  [ngClass]="{
    private: (isLoggedIn$ | async) === true && showMenu && isPublic !== true,
    public: (isLoggedIn$ | async) === true && showMenu && isPublic === true
  }"
>
  <div
    class="container"
    [ngClass]="{
      private: (isLoggedIn$ | async) === true && showMenu && isPublic !== true
    }"
  >
    <div class="nav-container-wrapper">
      <div>
        <!-- <div *carm-acl-group="[carmResource.MENU, groupType.Reader, true]"> -->
        <h2 class="wb-inv" *ngIf="showMenu">Menu</h2>
        <button
          type="button"
          (click)="toggleMenu()"
          aria-haspopup="true"
          *ngIf="showMenu && isPublic"
        >
          <span class="wb-inv">Main </span>Menu
          <span class="expicon glyphicon glyphicon-chevron-down"></span>
        </button>
        <ng-container  *ngIf="showMenu">
            <button
            type="button"
            (click)="toggleMenu()"
            aria-haspopup="true"
            *carm-acl-group="[carmResource.MENU, groupType.Reader, true]"
          >
            <span class="wb-inv">Main </span>Menu
            <span class="expicon glyphicon glyphicon-chevron-down"></span>
          </button>
        </ng-container>
      </div>
      <!--PRIVATE-->
      <div
        class="outer-menu-div"
        [ngClass]="{ menuOpen: headerMenuIsOpen }"
        *ngIf="(isLoggedIn$ | async) === true && showMenu && isPublic !== true"
      >
        <ul
          role="menu"
          aria-orientation="vertical"
          class="wb-init wb-data-ajax-replace-inited"
          data-ajax-replace=""
        >
        <ng-container *ngIf="(privateMenuItems | applyAcl)?.length === 1" > <!-- if only one item, don't show subsection -->
          <li role="presentation">
            <a
              role="menuitem"
              tabindex="0"
              aria-haspopup="true"
              aria-controls="gc-mnu-jobs"
              aria-expanded="false"
              href="#"
              [carmRouterLink]="privateMenuItems[0].path"
              >{{ privateMenuItems[0].localizationKey + '.title' | translate }}</a>
          </li>
        </ng-container>

          <ng-container *ngIf="privateMenuItems?.length >= 2" >
            <li *ngFor="let item of privateMenuItems | applyAcl | async" role="presentation">
              <a
                role="menuitem"
                tabindex="0"
                aria-haspopup="true"
                aria-controls="gc-mnu-jobs"
                aria-expanded="false"
                href="#"
                (click)="onMenuClick(item)"
                >{{ item.localizationKey + '.title' | translate }}</a>
              <ul role="menu" aria-orientation="vertical" class="grid-list" *ngIf="item.sections?.length > 0">
                <li role="presentation">
                  <a
                    role="menuitem"
                    tabindex="-1"
                    [carmRouterLink]="item.path"
                    class="menu-title"
                    >{{ item.localizationKey + '.title' | translate
                    }}<span class="visible-xs-inline visible-sm-inline"
                      >: home</span
                    ></a
                  >
                </li>
                <li role="separator"></li>
                <div *ngIf="item.sections">
                  <div class="link-container">
                    <li
                      class="link-width"
                      role="presentation"
                      *ngFor="let sublink of item.sections | applyAcl | async"
                    >
                      <a role="menuitem" tabindex="-1" [carmRouterLink]="sublink.path"
                        >{{
                          item.localizationKey +
                            '.sections.' +
                            sublink.localizationKey +
                            '.title' | translate
                        }}</a
                      >
                    </li>
                  </div>
                </div>
              </ul>
            </li>
          </ng-container>

        </ul>
      </div>

      <div
        id="logout-menu"
        class="flex-push-right right-menu"
        *ngIf="(isLoggedIn$ | async) === true && showMenu && isPublic !== true"
      >
        <div
          *ngIf="(userRole$ | async) && (userRole$ | async).roles.length === 0"
          ><a [carmRouterLink]="personalProfile" data-cy="personal-profile-link">{{
            'orphanLinks.personal_profile' | translate
          }}</a>
          <span class="split">|</span>
        </div>
        <div *carm-acl-group="[carmResource.NOTIFICATIONS, groupType.Reader, true]">
          <a [carmRouterLink]="notificationsRoute" data-cy="notifications-link">
            <span class="glyphicon glyphicon-bell"></span>
            <span>{{ 'main_header.notifications' | translate }}</span>
          </a>
          <span class="split-left">|</span>
        </div>
        <carm-main-header-setup-my-portal *ngIf="(isSetupMyPortalAllowed$ | async)?.length > 0" [isMenuOpen]="setupPortalMenuIsOpen"></carm-main-header-setup-my-portal>
        <div id="carmLogout"  class="margin-left-10" (click)="onLogout()">
          <a href="javascript:void(0);" data-cy="logout">
            <span class="glyphicon glyphicon-log-out"></span>
            <span>{{ 'main_header.logout' | translate }}</span>
          </a>
        </div>
      </div>

      <!--PUBLIC-->
      <div
        class="outer-menu-div"
        [ngClass]="{ menuOpen: headerMenuIsOpen }"
        *ngIf="
          ((isLoggedIn$ | async) === false && showMenu) ||
          ((isLoggedIn$ | async) === true && showMenu && isPublic === true)
        "
      >
        <ul
          role="menu"
          aria-orientation="vertical"
          class="wb-init wb-data-ajax-replace-inited"
          id="wb-auto-3"
          [attr.data-ajax-replace]="
            'https://www.canada.ca/content/dam/canada/sitemenu/sitemenu-v2-' +
            locale +
            '.html'
          "
        >
          <carm-public-menu-html-en
            *ngIf="locale === 'en'"
          ></carm-public-menu-html-en>
          <carm-public-menu-html-fr
            *ngIf="locale === 'fr'"
          ></carm-public-menu-html-fr>
        </ul>
      </div>
    </div>
  </div>
</nav>
